import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import {
  Inject,
  MaskedDateTime,
  TimePickerComponent,
} from '@syncfusion/ej2-react-calendars';
import './OpTimePicker.css';

export const OpTimePicker = (props) => {
  const {
    enabled = true, // toggle enable or disable the input
    enableMask = true, // prevents user from entering invalid values
    format = 'hh:mm a', // format of the time input
    maskPlaceholder = { hour: 'HH', minute: 'MM' }, // text place holder of the masked input
    onChange,
    placeholder,
    showClearButton = false, // toggle hide or visible the clear icon (x)
    showSelectTime = true, // toggle hide or visible the time selector icon
    validateInput, // function that return boolean if the input value is valid
    value, // value of the input
    width = 'auto',
  } = props;
  const timePickerRef = useRef(null);
  const [isInvalidInput, setIsInvalidInput] = useState(false);

  // Validate input if its complete
  const handleBlur = (params) => {
    if (typeof validateInput === 'function') {
      let isValid = false;
      const inputValue = timePickerRef.current.inputElement.value;

      // Flag as invalid if the input element has value and is incomplete
      if (inputValue?.length === 0 || params.model.value) isValid = true;
      setIsInvalidInput(isValid === false);
      validateInput(isValid);
    }
  };

  useEffect(() => {
    if (timePickerRef.current && value) {
      // set only once during mount
      timePickerRef.current.value = value;
    }
  }, []);

  const cssClasses = clsx(
    'op-time-picker',
    showSelectTime ? 'op-time-picker-hide-time-icon' : '',
    isInvalidInput ? 'op-time-picker-invalid' : '',
  );

  return (
    <>
      <TimePickerComponent
        blur={handleBlur}
        cssClass={cssClasses}
        enabled={enabled}
        enableMask={enableMask}
        format={format}
        maskPlaceholder={maskPlaceholder}
        onChange={onChange}
        placeholder={placeholder}
        ref={timePickerRef}
        showClearButton={showClearButton}
        width={width}
      >
        {enableMask && <Inject services={[MaskedDateTime]} />}
      </TimePickerComponent>
    </>
  );
};
